import React from "react";
import { PAYER_CONFIG } from "../config/payer";
import { PROVIDER_CONFIG } from "../config/provider";
import { useAuth0 } from "@auth0/auth0-react";

interface MainLayoutProps {
  username: string;
  onLogout?: () => void;
  children: React.ReactNode;
}

const MainLayout = ({ username, onLogout, children }: MainLayoutProps) => {
  const { logout: auth0Logout, isAuthenticated } = useAuth0();
  
  const handleLogout = () => {
    if (onLogout) {
      onLogout();
    } else if (isAuthenticated) {
      auth0Logout({ logoutParams: { returnTo: window.location.origin } });
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      {/* Top Navigation Bar */}
      <nav className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-gray-900">
                {PAYER_CONFIG.name} - {PROVIDER_CONFIG.name}
              </h1>
            </div>
            <div className="flex items-center gap-4">
              <span className="text-gray-600">
                Welcome, {username}
              </span>
              <button
                onClick={handleLogout}
                className="px-4 py-2 border rounded-md hover:bg-gray-50 transition-colors"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main className="flex-grow bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="bg-white rounded-lg shadow">{children}</div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-white border-t">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="text-center text-sm text-gray-500">
            © {new Date().getFullYear()} {PAYER_CONFIG.name}. All rights
            reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MainLayout;
